// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"5a39e204","629":"0ecb02cf","912":"32f32864"}[chunkId] + ".chunk.css";
};